import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-LabeledColour",
  "use": "icon-LabeledColour-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-LabeledColour\">\r\n<circle cx=\"12\" cy=\"12\" r=\"8\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol